import React from "react";
import SEO from "../common/SEO";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import FormTwo from "../component/contact/FormTwo";
import SectionTitle from "../elements/section-title/SectionTitle";
import ContactLocation from "../component/contact/ContactLocation";
import SectionTitle1 from "../elements/section-title/SectionTitle1";
import FormCareers from "../component/contact/FormCareers";
import FormEstimateProject from "../component/contact/FormEstimateProject";

const EstimateProject = () => {
  return (
    <>
      <SEO title="Blog Grid" />
      {/* <ColorSwitcher /> */}
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne
          title="Estimate Project"
          page="Estimateproject"
          subtitle=""
        />

        <div className="section custom-padding"  >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-12 col-lg-12">
                <div className="contact-form-box shadow-box mb--30">
                  <h3 className="title">Estimate your project</h3>
                  <FormEstimateProject />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section section-padding bg-color-dark overflow-hidden">
          <div className="container">
            <SectionTitle1
              subtitle="Find Us"
              title="Our office"
              description=""
              textAlignment="heading-light-left"
              textColor=""
            />
            <div className="row justify-content-center">
              <ContactLocation />
            </div>
          </div>
        </div>

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default EstimateProject;
